/* eslint-disable react/prop-types */
import React, { Fragment, useState } from 'react';
import { Button, Row, Col, FormGroup, Input, Form } from "reactstrap";
import LoadingModal from 'components/LoadingModal';
import InputDatePickerMesAno from "components/Inputs/InputDatePickerMesAno";
import MaterialTable from 'material-table';
import { table_translate, table_style } from "constants/MaterialTable.js";
import { monthDiff } from "utils/generics";
import { formateDateByMesAno } from "utils/formats";

function Presentational(props) {

  const {
    isLoadingCsv,
    onChangeFileHandler,
    onClickDownloadCsv,
    dataResult,
    alert,
    importDataCSV,
  } = props;

  return (
    <div>
      {alert}

      <div>
        <Row className="mt-4">
          <Col lg="4" md="8" sm="12">
            <Button round color="warning" onClick={onClickDownloadCsv}>
              Download modelo csv
            </Button>
          </Col>
          <Col lg="5" md="12" sm="12" className="mt-3">
            <FormGroup fullWidth>
              <Input
                type="file"
                label={"Arquivo *"}
                variant="outlined"
                name="arquivo"
                InputLabelProps={{ shrink: true }}
                onChange={onChangeFileHandler}
              />
            </FormGroup>
          </Col>
          <Col lg="3" md="6" sm="12">
            <label htmlFor="contained-button-file">
              <Button variant="contained" color="success" component="span" onClick={importDataCSV}>
                Upload Arquivo
              </Button>
            </label>
          </Col>
        </Row>
        <LoadingModal isLoading={isLoadingCsv} />

        {dataResult.length > 0 &&
          <Row>
            <Col lg="12" md="12" sm="12" style={{ marginTop: "75px" }}>
              <Form>
                <MaterialTable style={{ minHeight: "auto" }}
                  title="Lista de Importação"
                  columns={[
                    { title: 'Linha', field: 'linha' },
                    { title: 'Mês Ano', field: 'dadosDRE.mesAno_Obrigatorio' },
                    { title: 'Cust Code', field: 'dadosDRE.custCode_Obrigatorio' },
                    { title: 'Mensagem', field: 'mensagem' },
                    { title: 'Status Importação', field: 'sucessoImportacao', render: (rowData) => (<span>{rowData.sucessoImportacao ? <strong class="badge badge-success">Importado</strong> : <strong class="badge badge-danger"> Não Importado</strong>}</span>) }
                  ]}
                  data={dataResult}
                  isLoading={false}
                  localization={table_translate}
                  options={table_style}
                />
              </Form>
            </Col>
          </Row>
        }
      </div>

    </div>
  );
}

export default Presentational;
